export interface AgentChatInterface {
  url: string;
  chatId: string;
}

export const SIDE_SIZE_OF_CHAT_BUBBLE = 61;
